module.exports = __webpack_public_path__ + "static/img/bgimg4-2.bad8de0a.png";